export default "__VITE_ASSET__695a0fbe__"